import { units } from '@ui/css';
import { colors } from '@ui/kit/design-tokens';
import { combineTokens, makeScaleableToken } from '@utils/css';
import { makeSizeTokens } from '@utils/react/selectors';

const leftColumnSize = makeSizeTokens("--left-column", {
  height: "100%",
  width: units.px(175)
});
combineTokens("--pool-coupon", {
  containerPadding: [units.px(30), makeScaleableToken],
  background: colors.tertiary(),
  cellBackground: colors.tertiary({
    mix: {
      with: colors.gray.sim00,
      ratio: 0.4
    }
  })
});
const wrapper = "_35sw1tezjkm";
const scroller = "_35ssf21jka";
const table = "_35st1fxzzl3";
const thead = "_35st4f5qpa";
const tableHeadingCell = "_35st1ue7oz2";
const cell = "_35sc1jvk0j8";
const stickyLeftColumnCell = "_35ss1gxe4bz";
const stickyContentWrapper = "_35ss1uc9ord";
const stickyCellSpacer = "_35ss5s1kwk";
const cellContent = "_35scv2iq7j";

export { cell, cellContent, leftColumnSize, scroller, stickyCellSpacer, stickyContentWrapper, stickyLeftColumnCell, table, tableHeadingCell, thead, wrapper };
import "./_task.pool-coupon.style.linaria.module.css";
//# sourceMappingURL=_task.pool-coupon.style.js.map
